import { AxiosResponse } from 'axios';

import { CREDIT_AGREEMENT_TYPE } from '../../types';

import {
  CreditConstraintsResponse,
  CreditDetailsResponce,
  CreditResponse,
} from './dto/Credits';
import BaseApi from './BaseApi';

const creditsApi = {
  initCredit(
    token: string,
    payload: {
      amount: number;
      accountId: number;
      duration: number;
    }
  ): Promise<AxiosResponse<CreditResponse>> {
    return BaseApi.post('/api/v1/credits', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getCredits(
    token: string,
    payload: {
      accountId: number;
      count: number;
    }
  ): Promise<AxiosResponse<CreditResponse>> {
    return BaseApi.get(
      `/api/v1/credits?accountId=${payload.accountId}&count=${payload.count}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
  getCreditAgreement(
    token: string,
    payload: {
      creditId: number;
      accountId: number;
      type: CREDIT_AGREEMENT_TYPE;
      signed?: boolean;
    }
  ): Promise<AxiosResponse<ArrayBuffer>> {
    const { creditId, accountId, type, signed = false } = payload;
    return BaseApi.get(
      `/api/v1/credits/${creditId}/agreement?accountId=${accountId}&type=${type}&signed=${signed}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/pdf',
        },
        responseType: 'arraybuffer',
      }
    );
  },
  signCreditAgreement(
    token: string,
    payload: {
      operationId: number;
      accountId: number;
      hash: string;
      signature: string;
      type: CREDIT_AGREEMENT_TYPE;
      checksum: string;
    }
  ): Promise<AxiosResponse<CreditResponse>> {
    const { type, ...postData } = payload;
    return BaseApi.post(`/api/v1/credits/sign?&type=${type}`, postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getCreditConstraints(
    token: string
  ): Promise<AxiosResponse<CreditConstraintsResponse>> {
    return BaseApi.get(`/api/v1/credits/constraints`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getDetailsCreditInfo(
    token: string,
    payload: {
      id: number;
      accountId: number;
    }
  ): Promise<AxiosResponse<CreditDetailsResponce>> {
    const { id, accountId } = payload;
    return BaseApi.get(`/api/v1/credits/${id}/?accountId=${accountId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  closeCredit(
    token: string,
    payload: {
      id: number;
      accountId: number;
      creditInfo: CreditDetailsResponce;
    }
  ): Promise<AxiosResponse<CreditDetailsResponce>> {
    const { id, accountId, creditInfo } = payload;
    return BaseApi.post(
      `/api/v1/credits/${id}/close/?accountId=${accountId}`,
      creditInfo,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
};

export default creditsApi;
